var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "rebass";
import { Container } from "src/components/utilities/Containers";
import { theme } from "src/styles/theme";
import { DOCUMENTATION_URL, LANDING_HEADER_CANTON_URL, LANDING_FOOTER_COMMUNICATION_URL, LANDING_HEADER_DIP_URL, PRIVACY_POLICY_URL } from "src/utils/urls";
import styled from "styled-components";
var FooterStyled = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: rgba(0,0,0,0.3);\n  color: ", ";\n  text-align: center;\n  padding: 30px 20px;\n"], ["\n  background: rgba(0,0,0,0.3);\n  color: ", ";\n  text-align: center;\n  padding: 30px 20px;\n"])), theme.colors.white);
var FooterText = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  opacity: 0.9;\n  margin: 10px 0;\n"], ["\n  opacity: 0.9;\n  margin: 10px 0;\n"])));
var FooterLinks = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  gap: 10px 30px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  justify-content: center;\n  gap: 10px 30px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n"])));
var FooterLink = styled.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  opacity: 0.8;\n  transition: opacity 0.3s ease;\n  \n  &:hover {\n    opacity: 1;\n    text-decoration: underline;\n  }\n"], ["\n  color: ", ";\n  text-decoration: none;\n  opacity: 0.8;\n  transition: opacity 0.3s ease;\n  \n  &:hover {\n    opacity: 1;\n    text-decoration: underline;\n  }\n"])), theme.colors.white);
var Footer = function () {
    var t = useTranslation().t;
    var links = [
        {
            id: 1,
            href_url: DOCUMENTATION_URL,
            label: t('documentationLink')
        },
        {
            id: 2,
            href_url: LANDING_FOOTER_COMMUNICATION_URL,
            label: t('communicationLink')
        },
        {
            id: 3,
            href_url: PRIVACY_POLICY_URL,
            label: t('privacyPolicyLink')
        },
        {
            id: 4,
            href_url: LANDING_HEADER_CANTON_URL,
            label: t('cantonLink')
        },
        {
            id: 5,
            href_url: LANDING_HEADER_DIP_URL,
            label: t('dipLink')
        }
    ];
    return (React.createElement(FooterStyled, { as: "footer", lineHeight: "1", className: "screen", id: "footer" },
        React.createElement(Container, { css: "height: 100%;" },
            React.createElement(FooterText, null, t('footerText')),
            React.createElement(FooterLinks, null, links.map(function (link) { return (React.createElement(FooterLink, { key: link.id, href: link.href_url, target: "_blank" }, link.label)); })))));
};
export default Footer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
